import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import {
  ExperienceResource,
  ProgramSequenceProductDetails,
} from '../../../Common/Experience/Types';
import {
  ExperienceOverview,
  ExperienceWhatYouWillLearn,
  ExperienceWhoShouldAttend,
  ExperienceYouWillGain,
} from '../../Common';
import JourneyCard from './JourneyCard';
import SchoolPartners from './SchoolPartners';
import Steps from './Steps';

interface Props {
  experienceResource: ExperienceResource;
  productDetails: ProgramSequenceProductDetails;
}

function LearningJourneyDetails({ experienceResource, productDetails }: Props) {
  return (
    <div className="box-border flex flex-col gap-y-12 bg-white px-4 py-12 sm:p-12 md:gap-y-14">
      <SchoolPartners productDetails={productDetails} />
      <div className="relative h-full w-full">
        <Typography variant="h5" fontWeight="bold" className="mb-11">
          <T kind="Your Learning Journey" />
        </Typography>
        <div className="flex flex-col gap-y-3">
          {productDetails.sections.map((section, index) => (
            <section key={index} className="flex flex-col gap-x-7 sm:flex-row">
              <Steps index={index} length={productDetails.sections.length} />
              <JourneyCard section={section} />
            </section>
          ))}
        </div>
      </div>
      <ExperienceOverview experienceResource={experienceResource} />
      <div className="flex flex-col gap-6 xl:flex-row">
        <ExperienceWhatYouWillLearn experience={experienceResource.payload} />
        <div className="flex basis-4/12 flex-col gap-6 lg:flex-row xl:flex-col">
          <ExperienceWhoShouldAttend experience={experienceResource.payload} />
          <ExperienceYouWillGain experience={experienceResource.payload} />
        </div>
      </div>
    </div>
  );
}
export default observer(LearningJourneyDetails);
